module.exports = __webpack_public_path__ + "img/velans-tf-1.df6fc8b.jpg";